/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateTimeRegInput = {
    id?: string | null | undefined;
    ids?: Array<string | null> | null | undefined;
    updateTimeRegLocation?: boolean | null | undefined;
    taskId?: string | null | undefined;
    idleTimeId?: string | null | undefined;
    projectId?: string | null | undefined;
    roleId?: string | null | undefined;
    year?: number | null | undefined;
    month?: number | null | undefined;
    day?: number | null | undefined;
    minutesRegistered?: number | null | undefined;
    billableMinutesRegistered?: number | null | undefined;
    retainerConflictHandled?: boolean | null | undefined;
    removeOthersForTheDay?: boolean | null | undefined;
    notes?: string | null | undefined;
    harvestTaskId?: string | null | undefined;
    retryHarvest?: boolean | null | undefined;
    unit4ActivityId?: string | null | undefined;
    unit4ActivityName?: string | null | undefined;
    skipApprovalValidation?: boolean | null | undefined;
    overrideInvoiced?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateTimeRegistrationRetainerConflictMutationVariables = {
    input: UpdateTimeRegInput;
};
export type updateTimeRegistrationRetainerConflictMutationResponse = {
    readonly updateTimeReg: {
        readonly timeRegs: ReadonlyArray<{
            readonly id: string;
            readonly retainerConflictHandled: boolean | null;
        } | null> | null;
    } | null;
};
export type updateTimeRegistrationRetainerConflictMutation = {
    readonly response: updateTimeRegistrationRetainerConflictMutationResponse;
    readonly variables: updateTimeRegistrationRetainerConflictMutationVariables;
};



/*
mutation updateTimeRegistrationRetainerConflictMutation(
  $input: UpdateTimeRegInput!
) {
  updateTimeReg(input: $input) {
    timeRegs {
      id
      retainerConflictHandled
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateTimeRegInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTimeRegPayload",
    "kind": "LinkedField",
    "name": "updateTimeReg",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRegType",
        "kind": "LinkedField",
        "name": "timeRegs",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "retainerConflictHandled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTimeRegistrationRetainerConflictMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTimeRegistrationRetainerConflictMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateTimeRegistrationRetainerConflictMutation",
    "operationKind": "mutation",
    "text": "mutation updateTimeRegistrationRetainerConflictMutation(\n  $input: UpdateTimeRegInput!\n) {\n  updateTimeReg(input: $input) {\n    timeRegs {\n      id\n      retainerConflictHandled\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ccadd9d9180e46461fe1892098dd341a';
export default node;
